/* eslint-disable import/max-dependencies */
import React from "react";
import { withHookPropsState } from "@fas/cpa-cabinet-ui";
import DialogComponent from "@fas/cpa-cabinet-ui/lib/DateRangePicker/DateRangeDialog";
import DateRangePresetsDefault from "@fas/cpa-cabinet-ui/lib/DateRangePicker/DateRangePresets";
import DateRangeDateCellDefault from "@fas/cpa-cabinet-ui/lib/DateRangePicker/DateRangeDateCell";
import dayjs from "dayjs";
import { withStyles } from "@mui/styles";
import { maxDate, minDate, presets } from "./presets";
import DateRangeFooter from "../DateRangeFooter";
import SelectBody from "../SelectPopup/SelectBody";
import { useDictionaryValueList } from "../../hooks/useDictionaryValueList";
import TextFieldMultiselectBody from "../TextFieldMultiselect/TextFieldMultiselectBody";
import { useMemoryOptions } from "../../hooks/useMemoryOptions";

const StyledTextFieldMultiselectBody = withHookPropsState(
  withStyles({
    popper: {
      maxWidth: "360px",
    },
  })(TextFieldMultiselectBody),
  useMemoryOptions
);
const DateRangePicker = withStyles({})(DialogComponent);
const CountrySelect = withHookPropsState(SelectBody, useDictionaryValueList);
const SmartlinkNameSelect = withHookPropsState(SelectBody, useDictionaryValueList);
// eslint-disable-next-line import/prefer-default-export
export const mainReportColumnsMap = {
  date: {
    field: "date",
    label: "Date",
    searchable: true,
    sortable: true,
    SearchComponent: ({ onClose, onChange, value }: any): any => {
      const changeDates: any = ({
        startDate: start,
        endDate: end,
      }: {
        startDate: any;
        endDate: any;
      }) => {
        onChange({
          date: {
            from: dayjs(start).format("YYYY-MM-DD"),
            to: dayjs(end).format("YYYY-MM-DD"),
          },
        });
        onClose();
      };

      return (
        <DateRangePicker
          applyOnClose
          applyOnSelect
          startDate={value.from}
          endDate={value.to}
          onChange={changeDates}
          onChangePreset={changeDates}
          onClose={onClose}
          currentPreset=""
          presets={presets}
          minDate={minDate}
          maxDate={maxDate}
          CellComponent={DateRangeDateCellDefault}
          PresetsComponent={DateRangePresetsDefault}
          FooterComponent={DateRangeFooter}
        />
      );
    },
  },
  country: {
    field: "country",
    label: "Country",
    searchable: true,
    sortable: true,
    SearchComponent: ({ ...props }: any): any => (
      <CountrySelect
        {...props}
        label="Country"
        hookProps="country"
        onChange={(country: string | string[]): any =>
          props.onChange({
            country,
          })
        }
        defaultValue={[]}
        isSplitListBoxColumn
      />
    ),
  },
  subId: {
    field: "subId",
    label: "Subid",
    searchable: true,
    sortable: true,
    SearchComponent: ({ value, onChange }: any): any => (
      <StyledTextFieldMultiselectBody
        hookProps="subIdMain"
        value={value}
        label="Subid"
        placeholder="Input subId"
        name="subId"
        onChange={(subId: string | string[]): any =>
          onChange({
            subId,
          })
        }
      />
    ),
  },
  smartlink_name: {
    field: "smartlink_name",
    label: "Smartlink Name",
    searchable: true,
    sortable: true,
    SearchComponent: ({ ...props }: any): any => (
      <SmartlinkNameSelect
        {...props}
        label="Smartlink Name"
        hookProps="smartlinkName"
        onChange={(name: string | string[]): any =>
          props.onChange({
            smartlink_name: name,
          })
        }
        defaultValue={[]}
        maxSelection={10}
      />
    ),
    render: ({ smartlink_name: smartlinkName }: any): any => (
      <span
        style={{
          whiteSpace: "pre",
        }}
      >
        {smartlinkName}
      </span>
    ),
  },
  smartClicks: {
    field: "smartClicks",
    label: "SmartClicks",
    sortable: true,
  },
  leads: {
    field: "leads",
    label: "Leads",
    sortable: true,
  },
  installs: {
    field: "installs",
    label: "Installs",
    sortable: true,
  },
  sales: {
    field: "sales",
    label: "Sales",
    sortable: true,
  },
  smartClick2lead: {
    field: "smartClick2lead",
    label: "SmartClick2Lead %",
    sortable: true,
  },
  epc: {
    field: "epc",
    label: "EPC $",
    sortable: true,
  },
  revenue: {
    field: "revenue",
    label: "Revenue $",
    sortable: true,
  },
  additional_revenue: {
    field: "additional_revenue",
    label: "Additional revenue $",
    sortable: true,
  },
  total_revenue: {
    field: "total_revenue",
    label: "Total revenue $",
    sortable: true,
  },
};
